import React, {useState} from 'react';
import InvoiceGeneratorController from "../../../invoiceGenerator/controller/invoiceGeneratorController";
import AppSettingController from "../../../Main/controller/AppSettingController";
import {ReactComponent as DeleteIcon} from "../../assets/icons/delete.svg";
import {ReactComponent as PrintIcon} from "../../assets/icons/print.svg";
import {Spinner} from "react-bootstrap";

function PrintItem({printer}: {
    printer: {
        id: string,
        ip: string,
        port: number,
        name: string,
    }
}) {
    const [loading, setLoading] = useState(false);

    return (
        <div key={printer.id} className={'desk-item'}>
            <p>{printer.name ? `${printer.name} - ` : ''}{printer.ip}:{printer.port}</p>
            <div>
                {!loading ? <PrintIcon
                        className={'delete-icon'}
                        onClick={e => new InvoiceGeneratorController().printTest(printer.ip, printer.port, setLoading)}/> :
                    <Spinner/>}
                <DeleteIcon onClick={e => AppSettingController.deletePrinter(printer.id)}/>
            </div>
        </div>
    );
}

export default PrintItem;